<template>
	<section class="hero">
		<div class="hero__container">
			<GlobalImage
				loading="eager"
				fetchpriority="high"
				:lazyLoad="false"
				class="hero__image"
				:alt="$t('modules.departments_page_module.location_page_hero.car_rental', { city: cmsLocation?.[`name${locale.toUpperCase()}`] })"
				:src="bannerIMG ? `${storageUrl}${bannerIMG}` : locationHeroIMG"
				:height="1160" />
			<GlobalImage
				loading="eager"
				fetchpriority="high"
				:lazyLoad="false"
				class="hero__image-mobile"
				:alt="
					isElectricPageCase
						? $t('modules.departments_page_module.location_page_hero.electric_car_renatl')
						: $t('modules.departments_page_module.location_page_hero.car_rental', { city: cmsLocation?.[`name${locale.toUpperCase()}`] })
				"
				:src="bannerIMG ? `${storageUrl}${bannerIMG}` : locationHeroIMG"
				:height="970" />
			<h1 class="hero__title">
				<template v-if="isElectricPageCase">
					{{ $t('modules.departments_page_module.location_page_hero.electric_car_rental') }}
				</template>
				<template v-else>
					{{ $t('modules.departments_page_module.location_page_hero.car_rental', { city: cmsLocation?.[`name${locale.toUpperCase()}`] }) }}
				</template>
			</h1>
			<div class="hero__gradient"></div>
			<div ref="bookerContainerRef" class="hero__booker-container" data-aos="fade-up" data-aos-delay="200">
				<div class="hero__days-months-google-container">
					<GlobalBookerDaysMonths />
					<LocationGoogleReviews />
				</div>
				<div class="hero__global-booker-wrapper">
					<GlobalBooker location />
				</div>
			</div>
			<GlobalBookerAdvantages data-aos="fade-up" data-aos-delay="300" />
		</div>
	</section>
</template>

<script setup lang="ts">
const { locale } = useI18n()
const pageHeaderSection = inject<Ref<ICMSLocationContent>>('pageHeaderSection') || ref<ICMSLocationContent>([])
const cmsLocation = inject<Ref<ICMSLocation>>('cmsLocation') || ref<ICMSLocation>([])
const bannerIMG = ref<string>()
const bookerHeight = ref()
const route = useRoute()
const { storageUrl, locationHeroIMG } = useStorageService()

const isElectricPageCase = computed(() => route.fullPath.includes('wypozyczalnia-samochodow-elektrycznych'))

const assignBannerIMG = () => {
	if (!pageHeaderSection.value) return null
	if (pageHeaderSection.value.files && pageHeaderSection.value.files.length > 0) {
		const img = pageHeaderSection.value.files[0].path
		if (img) bannerIMG.value = img
	}
}

assignBannerIMG()

const bookerContainerRef = ref<HTMLElement | null>(null)

const assignBookerWrapperHeight = () => {
	if (bookerHeight.value) return

	const globalBooker = document.querySelector('.hero__global-booker-wrapper')
	if (globalBooker) {
		bookerHeight.value = globalBooker.clientHeight
	}
}

onMounted(() => {
	window.addEventListener('scroll', assignBookerWrapperHeight)

	setTimeout(() => {
		if (bookerContainerRef.value) {
			bookerContainerRef.value.style.transform = 'none'
		}
	}, 250)
})
</script>

<style scoped lang="scss">
@import './PageHero.scss';
</style>
